export const GUEST_JUPAS_LOGIN_HINT_KEY = 'edvise_guest_jupas_login_hint';
export const GUEST_JUPAS_LOGIN_HINT_EVENT = 'edvise:guest-jupas-login-hint';

const HINT_ACTIVE = 'active';
const HINT_DISMISSED = 'dismissed';

export function shouldShowGuestJupasLoginHint() {
  if (typeof window === 'undefined') return false;
  return localStorage.getItem(GUEST_JUPAS_LOGIN_HINT_KEY) === HINT_ACTIVE;
}

export function triggerGuestJupasLoginHint() {
  if (typeof window === 'undefined') return false;
  if (localStorage.getItem(GUEST_JUPAS_LOGIN_HINT_KEY) === HINT_DISMISSED) {
    return false;
  }
  localStorage.setItem(GUEST_JUPAS_LOGIN_HINT_KEY, HINT_ACTIVE);
  window.dispatchEvent(new CustomEvent(GUEST_JUPAS_LOGIN_HINT_EVENT));
  return true;
}

export function dismissGuestJupasLoginHint() {
  if (typeof window === 'undefined') return;
  localStorage.setItem(GUEST_JUPAS_LOGIN_HINT_KEY, HINT_DISMISSED);
  window.dispatchEvent(new CustomEvent(GUEST_JUPAS_LOGIN_HINT_EVENT, { detail: { dismissed: true } }));
}
